// Etichetta breve catastale da un tipologia testuale PVP (es.
// "Abitazione Tipo Economico" → "A/3 Economico"). Marina 2026-07-12.
export function tipoCatasto(t) {
  if (!t) return null;
  const s = String(t).toLowerCase();
  if (s.includes('sign')) return 'A/1 Signorile';
  if (s.includes('civ')) return 'A/2 Civile';
  if (s.includes('econom') || /\beco\b/.test(s)) return 'A/3 Economico';
  if (s.includes('popolar') || /\bpop\b/.test(s)) return 'A/4 Popolare';
  if (s.includes('ultrapop')) return 'A/5';
  if (s.includes('rural')) return 'A/6';
  if (s.includes('villin')) return 'A/7 Villino';
  if (s.includes('ville') || s.includes('villa')) return 'A/8 Villa';
  if (s.includes('appartament')) return 'Appartamento';
  if (s.includes('box') || s.includes('autorimess')) return 'Box';
  if (s.includes('negoz') || s.includes('c/1')) return 'Negozio';
  if (s.includes('ufficio') || s.includes('a/10')) return 'Ufficio';
  if (s.includes('terren')) return 'Terreno';
  // codice A/x già presente nel testo
  const m = s.match(/\ba\s*\/?\s*(\d{1,2})\b/);
  if (m) return 'A/' + m[1];
  // fallback: prime 2 parole
  return t.split(' ').slice(0, 2).join(' ');
}

// Nome tipologia "in chiaro" (senza codici catastali), stile immobiliare.it:
// es. "Abitazione Tipo Economico" → "Appartamento", "Abitazione In Ville" → "Villa".
export function tipoNome(t) {
  if (!t) return 'Immobile';
  const s = String(t).toLowerCase();
  if (s.includes('villin')) return 'Villino';
  if (s.includes('ville') || s.includes('villa')) return 'Villa';
  if (s.includes('appartament')) return 'Appartamento';
  if (s.includes('abitazione') || /\ba\s*\/?\s*[1-6]\b/.test(s)) return 'Appartamento';
  if (s.includes('box') || s.includes('autorimess')) return 'Box';
  if (s.includes('negoz')) return 'Negozio';
  if (s.includes('ufficio')) return 'Ufficio';
  if (s.includes('terren')) return 'Terreno';
  if (s.includes('magazzin') || s.includes('deposit')) return 'Magazzino';
  if (s.includes('capannon') || s.includes('industri')) return 'Capannone';
  const w = t.split(' ')[0];
  return w ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : 'Immobile';
}

// Scompone un indirizzo geocodificato Google (es. "Via Bondeno, 74, 00127
// Vitinia RM, Italia") in { via, localita }. La località (frazione) spesso è
// l'unico posto dove compare il quartiere reale quando il comune è la città
// capoluogo (Vitinia → comune Roma). Toglie CAP, sigla provincia e nazione.
export function parseIndirizzo(raw) {
  if (!raw) return { via: '', localita: '' };
  let s = String(raw).trim().replace(/\.\s*$/, '');       // punto finale
  s = s.replace(/,\s*(italia|italy)\s*$/i, '');           // nazione
  s = s.replace(/\s+[A-Z]{2}\s*$/, '');                   // sigla provincia (RM, MI…)
  let localita = '';
  let via = s;
  const m = s.match(/(\d{5})\s+(.+)$/);                   // CAP + località in coda
  if (m) {
    localita = m[2].trim();
    via = s.slice(0, m.index).replace(/[,\s]+$/, '').trim();
  }
  return { via, localita };
}

// Città + zona, evitando il doppione quando zona coincide col comune
// (piccoli comuni: zona = "Agosta" == comune "Agosta").
export function luoghi(comune, zona) {
  const out = [];
  if (comune) out.push(comune);
  if (zona && (!comune || String(zona).trim().toLowerCase() !== String(comune).trim().toLowerCase())) out.push(zona);
  return out;
}
